// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    CREATE_RECAP_REQUEST: null,
    CREATE_RECAP_SUCCESS: null,
    CREATE_RECAP_FAILURE: null,

    RECEIVED_RECAP: null,
    RECEIVED_RECAPS: null,

    GET_RECAP_REQUEST: null,
    GET_RECAP_SUCCESS: null,
    GET_RECAP_FAILURE: null,

    GET_RECAPS_REQUEST: null,
    GET_RECAPS_SUCCESS: null,
    GET_RECAPS_FAILURE: null,

    MARK_RECAP_READ_REQUEST: null,
    MARK_RECAP_READ_SUCCESS: null,
    MARK_RECAP_READ_FAILURE: null,

    DELETE_RECAP_REQUEST: null,
    DELETE_RECAP_SUCCESS: null,
    DELETE_RECAP_FAILURE: null,

    REGENERATE_RECAP_REQUEST: null,
    REGENERATE_RECAP_SUCCESS: null,
    REGENERATE_RECAP_FAILURE: null,
});

